import PropTypes from "prop-types";
import React from "react";
import ENV from "app/utils/ENV";
import { View, TouchableOpacity, TouchableWithoutFeedback } from "react-native";
import valueHelpers from "app/utils/valueHelpers";
import colorHelpers from "app/utils/colorHelpers";
import richTextHelpers from "app/utils/richTextHelpers";
import valueActions from "app/utils/valueActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import store from "app/redux/store";

import Text from "app/components/Text";
import RichText from "app/components/RichText";
import TextInput from "app/components/TextInput";
import Autocomplete from "app/components/Autocomplete";
import MultiButton from "app/components/MultiButton";
import Hoverable from "app/components/Hoverable";
import MomentBullet from "app/components/chapter/MomentBullet";

import { StyleContext } from "app/contexts/Style";

export default class RichTextInput extends React.Component {
  static contextType = StyleContext;
  constructor(props) {
    super(props);
    let indexData = this.findStartingIndex(props.children);
    this.state = {
      query: "",
      selection: null,
      nativeSelection: {},
      isDirty: false,
      values: [],
      // editing: props.autoFocus ? true : false,
      editing: false,
      shadowText: "",
      fullShadowText: props.children,
      caretPos: 0,
      caretLine: 1,
      bottomLine: null,
      startingIndex: indexData.caretPos,
      indentation: indexData.indentation,
      hideCaret: true,
      isMomentBullet: false,
      // isMomentBullet:
      //   props.momentBulletRefs &&
      //   props.children?.startsWith("{") &&
      //   props.children?.endsWith("}"),
      momentBulletIds: [],
      query: "",
      foldedSections: {}, // { [lineIndex]: true } means expanded; missing/false means collapsed
    };
  }

  toggleFold = (key) => {
    this.setState((prev) => ({
      foldedSections: {
        ...prev.foldedSections,
        [key]: !prev.foldedSections[key],
      },
    }));
  };

  findStartingIndex = (text) => {
    let indentation = richTextHelpers.getIndentation(text);
    let index = richTextHelpers.findStartingIndex(text);
    return { caretPos: index, indentation };
  };

  focus = async (caretPos = 0, selectionEnd = undefined) => {
    this.props.onFocus && this.props.onFocus();
    if (this.state.isMomentBullet && !this.state.plainText) {
      if (this.inputRef) {
        this.inputRef?.focus();
        return;
      } else console.log("missing momentbullet ref");
    }
    await this.setState({ editing: true });
    await new Promise((r) => setTimeout(r, 0));
    this.updateCursorValues();
    let indexData = this.findStartingIndex(this.props.children);
    let startingIndex = indexData.caretPos;
    let indentation = indexData.indentation;
    // if (caretPos == 0) {

    // adjust for markdown
    caretPos = richTextHelpers.adjustIndexForPlainText(
      caretPos,
      this.props.children,
    );

    // adjust for indentation / bullets
    caretPos += indexData.caretPos;

    // }
    if (caretPos > this.props.children.length)
      caretPos = this.props.children.length;
    if (ENV.WEB) {
      !!this.inputRef?.setSelectionRange &&
        this.inputRef.setSelectionRange(caretPos, selectionEnd || caretPos);
    } else {
      !!this.inputRef?.setNativeProps &&
        this.inputRef.setNativeProps({
          selection: { start: caretPos, end: selectionEnd || caretPos },
        });
    }
    this.setCaret(false, caretPos);
    this.setState({ caretPos, hideCaret: false, startingIndex, indentation });
    // this.inputRef.setSelectionRange(caretPos, selectionEnd [, selectionDirection]);
    // selectionDirection Optional
    // A string indicating the direction in which the selection is considered to have been performed. Possible values:
    // "forward"
    // "backward"
    // "none" if the direction is unknown or irrelevant. Default value.
  };

  updateCursorValues = () => {
    let indexData = this.findStartingIndex(this.props.children);
    let startingIndex = indexData.caretPos;
    let indentation = indexData.indentation;
    this.setState({ startingIndex, indentation });
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.children != this.props.children) {
      this.updateCursorValues();
    }
    // if (prevProps.numberOfLines != this.props.numberOfLines) {
    //   this.setBottomLine();
    // }
  };

  render() {
    let { editing, hideCaret, plainText, query, isMomentBullet } = this.state;
    let {
      children,
      selected,
      lineIndex,
      canFold,
      folded,
      momentBulletRefs,
      numberOfLines,
    } = this.props;
    let text = children;

    if (momentBulletRefs && !plainText) {
      // if (text.startsWith("{") && text.endsWith("}")) {
      if (isMomentBullet) {
        let expanded = text.includes("-expanded");
        let id = text.replace(/[{}|]/g, "").replace(/-.*/, "");
        let value = this.props.references?.find((v) => v.id == id);
        if (value) {
          let color =
            valueHelpers.getColor(value, this.context.colorScheme) ||
            this.context.colors.trim;
          let backgroundColor = colorHelpers.hexToRgbaString(color, 0.2);
          backgroundColor = null;
          return (
            <MomentBullet
              // rti
              ref={(ref) => {
                if (this.props.inputRef) {
                  this.props.inputRef(ref);
                }
                this.inputRef = ref;
                return (this.inputRef = ref);
              }}
              expanded={expanded}
              hideBadgeRow
              wrapperStyle={{
                backgroundColor: selected
                  ? this.context.colors.highlight
                  : backgroundColor,
                borderRadius: this.context.sizes.borderRadius,
                paddingVertical: this.context.sizes.small,
              }}
              moment={{
                value,
              }}
              onFocus={() => {
                this.props.onFocus && this.props.onFocus();
              }}
              defaultFocus={this.props.defaultFocus}
              focusPrevious={this.props.focusPrevious}
              focusNext={this.props.focusNext}
              focusParentMoment={() => this.focus()}
              onEscape={async () => {
                await this.setState({ plainText: true, editing: true });
                this.focus();
              }}
            />
          );
        }
      }
    }

    let snapshotStyle = { background: {}, text: {} };
    if (this.props.snapshotStatus == "added") {
      let valueColor = valueHelpers.getColor(
        this.props.value,
        this.context.colorScheme,
      );
      snapshotStyle.background = {
        backgroundColor: colorHelpers.hexToRgbaString(valueColor, 0.2),
      };
    } else if (this.props.snapshotStatus == "removed") {
      snapshotStyle.text = {
        opacity: 0.8,
        textDecorationLine: "line-through",
      };
      let removedColor = this.context.colors.foreground;
      snapshotStyle.background = {
        backgroundColor: colorHelpers.hexToRgbaString(removedColor, 0.1),
      };
    }

    if (!editing || this.props.readOnly) {
      return (
        <TouchableWithoutFeedback
          disabled={this.props.readOnly}
          onPress={async (e) => {
            // Don't focus if user clicked on a link or button
            if (ENV.WEB) {
              const target = e?.target || e?.nativeEvent?.target;
              // Check if clicked element or any parent is a link/button
              let element = target;
              while (element && element !== e.currentTarget) {
                const role = element.getAttribute?.('role');
                if (element.tagName === 'A' ||
                    role === 'button' ||
                    role === 'link' ||
                    element.onclick ||
                    element.style?.cursor === 'pointer') {
                  return; // Don't focus
                }
                element = element.parentElement;
              }
              // On web, get cursor position from selection
              let caretPos = !!window?.getSelection
                ? window?.getSelection().anchorOffset
                : 0;
              this.focus(caretPos);
            } else {
              // On iOS/Android, always start at position 0
              this.focus(0);
            }
          }}
          style={[{ cursor: "text" }]}
          nativeID={
            this.props.defaultFocus
              ? `default-focus-${window?.location?.href}`
              : ""
          }
        >
          <View style={[{ flex: 1 }, this.props.hidden && { opacity: 0.5 }]}>
            {false && canFold && (
              <View style={{ position: "absolute", left: -15 }}>
                <Text onPress={this.props.toggleFolded}>
                  {folded ? ">" : "V"}
                </Text>
              </View>
            )}
            <RichText
              value={this.props.value}
              chapter={this.props.chapter}
              references={this.props.references}
              log
              color={this.props.color || this.context.colors.foreground}
              // backgroundColor={this.props.backgroundColor}
              bold={this.props.bold}
              plaintext={this.props.plaintext}
              // defaultFocus={this.props.defaultFocus}
              style={{
                ...this.context.styleSheet.input,
                minHeight: this.context.sizes.default * 1.6,
                ...snapshotStyle.text,
                ...(this.props.textStyle || {}),
              }}
              wrapperStyle={[
                selected && {
                  backgroundColor: this.context.colors.highlight,
                  // backgroundColor: "red",
                },
                snapshotStyle.background,
                !!this.props.backgroundColor && {
                  backgroundColor: this.props.backgroundColor,
                },
              ]}
              // value={value}
              snapshotText={this.props.snapshotText}
              foldExpanded={this.props.foldExpanded}
              onToggleFold={this.props.onToggleFold}
            >
              {text}
            </RichText>
          </View>
        </TouchableWithoutFeedback>
      );
    } else {
      return (
        <View
          style={[
            { flex: 1 },
            this.props.hidden && { opacity: 0.5 },
            { overflow: "visible" },
          ]}
        >
          <TextInput
            // inputRef={this.props.inputRef}
            defaultFocus={this.props.defaultFocus}
            inputRef={(ref) => {
              if (this.props.inputRef) {
                this.props.inputRef(ref);
              }
              return (this.inputRef = ref);
            }}
            onSelectionChange={(event) => {
              let selection = event.nativeEvent.selection;
              this.setState({ nativeSelection: selection });
            }}
            value={text}
            multiline
            autoHeight
            autoFocus
            onFocus={() => {
              // this doesnt fire initially when autoFocus is true
              // console.error("onfocus??");
              // this.focus(); // disabling this one for now
            }}
            // inputRef={(r) => (this.input = r)}
            style={[
              hideCaret && { caretColor: "transparent" },
              {
                lineHeight: this.context.sizes.default * 1.6,
                // minHeight: this.context.sizes.giant,
                // borderWidth: 1,
                borderColor: "red",
                backgroundColor: colorHelpers.hexToRgbaString(
                  this.context.colors.trim,
                  0.2,
                ),
              },
              selected && {
                backgroundColor: this.context.colors.highlight,
                // backgroundColor: "red",
              },
              ...this.inputMarkDownStyling(text),
            ]}
            onChangeText={(lineText) => {
              // lineText = richTextHelpers.formatBullets(lineText);
              // this.setState({ fullShadowText: lineText });
              // console.log("change text", lineText, this.props.children);
              this.props.onChangeText(lineText);
              // console.log(text);
              // return;
              // let fullText = text
              //   .split(/[\r\n]/)
              //   .map((l, j) => {
              //     if (j == i) return lineText;
              //     else return l;
              //   })
              //   .join(`\n`);
              // this.setState({ text: fullText, isDirty: true });
              // this.handleChangeText();
            }}
            onBlur={() => {
              // console.log("cancel timeout!!!!!");
              !!this.selectionTimeout && clearTimeout(this.selectionTimeout);
              this.stopEditing();
            }}
            onKeyPress={this.handleKeyPress}
            // onMouseMove={(e) => {
            //   console.log("move");
            // }}
            onMouseLeave={(e) => {
            }}
            onMouseUp={(e) => {
              this.setCaret();

              // let query = null;
              // let selection = null;
              // if (
              //   (!!this.inputRef?.selectionStart ||
              //     this.inputRef?.selectionStart == 0) &&
              //   !!this.inputRef?.selectionEnd &&
              //   this.inputRef.selectionStart != this.inputRef.selectionEnd
              // ) {
              //   selection = [
              //     this.inputRef.selectionStart,
              //     this.inputRef.selectionEnd,
              //     lineIndex,
              //   ];
              // }
              // if (selection) {
              //   query = text.slice(selection[0], selection[1]);
              //   query = query.trim();
              // }
              // this.setState({ query, selection });
              // this.props.onMouseUp && this.props.onMouseUp(e, selection);
            }}
          />
          <View
            pointerEvents="none"
            style={{
              left: 0,
              right: 0,
              position: "absolute",
              opacity: 0.3,
              opacity: 0,
              backgroundColor: "green",
              // transform: [{ translateY: -100 }],
            }}
            ref={(ref) => (this.shadowRef = ref)}
            // onLayout={() => {
            //   console.log("layout...");
            //   if (!this.state.bottomLine)
            //     this.shadowRef?.measure((x, y, width, height) => {
            //       let lineHeight = this.context.sizes.default * 1.6;
            //       let bottomLine = Math.floor(height / lineHeight);
            //       console.log("set bottomLine", bottomLine);
            //       this.setState({ bottomLine });
            //       this.setCaret();
            //     });
            // }}
          >
            <Text
              multiline
              style={[
                {
                  lineHeight: this.context.sizes.default * 1.6,
                  ...this.context.styleSheet.input,
                  color: "red",
                },
              ]}
            >
              {this.state.shadowText || "-"}
            </Text>
          </View>
          <View
            pointerEvents="none"
            style={{
              left: 0,
              right: 0,
              position: "absolute",
              opacity: 0.2,
              opacity: 0,
              backgroundColor: "black",
              // transform: [{ translateY: -100 }],
            }}
            ref={(ref) => (this.fullShadowRef = ref)}
            onLayout={() => {
              this.setBottomLine();
              // if (!this.state.bottomLine)
            }}
          >
            <Text
              multiline
              style={[
                {
                  lineHeight: this.context.sizes.default * 1.6,
                  ...this.context.styleSheet.input,
                  color: "white",
                },
              ]}
            >
              {this.state.fullShadowText || "-"}
            </Text>
          </View>

          {!!query?.length && !this.props.hideAutocomplete && (
            <View
              style={[this.styles().autocompleteWrapper]}
              // pointerEvents={this.state.mouseDownOnLine !== null && "none"}
            >
              <Autocomplete
                ref={(r) => (this.autocompleteRef = r)}
                suggestionsOnly
                simpleListView
                query={query}
                excludeIds={[this.props.value?.id]}
                backgroundColor={this.context.colors.trim}
                onSelectItem={(value, e) => {
                  e.preventDefault();
                  this.injectReference(value);
                }}
                onEnter={(value, e) => {
                  e.preventDefault();
                  if (!!value) {
                    this.injectReference(value);
                  } else {
                    this.handleCreateFromQuery();
                  }
                }}
                submitFirstOnPressEnter
                submitFirstOnPressTab
              />
              <Text
                button
                numberOfLines={1}
                onMouseDown={() => this.handleCreateFromQuery()}
                // Create "{query.trim()}"
              >
                Create Note
              </Text>
              <Text
                button
                numberOfLines={1}
                onMouseDown={() => this.handleCreateFromQuery(true)}
              >
                Create Project
              </Text>
            </View>
          )}
        </View>
      );
    }
  }

  setCaret = async (updateSelection = true, setCaretPos = 0) => {
    // if (!ENV.WEB) return;
    if (this.state.bottomLine == null) return;
    let text = this.props.children;
    let { nativeSelection } = this.state;
    await new Promise((r) => setTimeout(r, 0));
    let selection = ENV.WEB
      ? [this.inputRef?.selectionStart, this.inputRef?.selectionEnd]
      : [nativeSelection.start || 0, nativeSelection.end || null];
    // console.log("setting carret");
    let caretPos = selection[0] || setCaretPos;
    let shadowText = text.slice(0, caretPos);
    // if we are in the whitespace at the end of the line
    // include the next word
    // if (shadowText.endsWith(" ")) {
    // shadowText = shadowText.replace(/.$/, "-");
    let nextWord = text.slice(caretPos).split(" ")[0] || "";
    shadowText += `${nextWord}`;
    // }
    // this.setState({ caretPos, shadowText });
    // console.log("caretpos", caretPos);
    this.setState({ caretPos, shadowText, fullShadowText: text });

    let caretLine = 1;
    this.shadowRef?.measure(async (x, y, width, height) => {
      let lineHeight = this.context.sizes.default * 1.6;
      caretLine = Math.floor(height / lineHeight);
      // console.error(caretLine);
      // console.log("currentLine", caretLine, caretPos);
      await this.setState({ caretLine });
      // console.log(caretLine, shadowText);
    });
    // this.setState({ caretPos, caretLine });

    if (updateSelection) {
      this.setState({ selection });
      if (selection[0] != undefined && selection[1] != undefined) {
        let query = text.slice(selection[0], selection[1]);
        query = query.trim();
        this.setState({ query });

        let startingIndex = this.findStartingIndex(
          this.props.children,
        ).caretPos;
        if (
          selection[0] <= startingIndex &&
          selection[1] > selection[0] &&
          selection[1] == text.length
        ) {
          // this.selectionTimeout = setTimeout(() => {
          // this.stopEditing();
          this.props.toggleSelected && this.props.toggleSelected(true);
          // }, 900);
        } else {
          !!this.selectionTimeout && clearTimeout(this.selectionTimeout);
          this.props.toggleSelected && this.props.toggleSelected(false);
        }
      }
    }
  };

  setBottomLine = () => {
    // let { numberOfLines } = this.props;
    this.fullShadowRef?.measure((x, y, width, height) => {
      let lineHeight = this.context.sizes.default * 1.6;
      let bottomLine = Math.floor(height / lineHeight);
      console.log("set bottom line", bottomLine);
      // if (!!numberOfLines) bottomLine = Math.min(bottomLine, numberOfLines);
      this.setState({ bottomLine });
      // this.setCaret();
    });
  };

  handleKeyPress = async (event) => {
    // this.setCaret();
    // let caretPos = this.inputRef?.caretPos || 0;
    let {
      caretPos,
      indentation,
      caretLine,
      bottomLine,
      startingIndex,
      query,
      selection,
    } = this.state;
    let text = this.props.children;

    let handled = !!this.props.handleKeyDown && this.props.handleKeyDown(event);
    if (handled == true) {
      console.log("hadled by parent");
      return;
    }

    let key = event.nativeEvent.key;
    console.log("textinput keypress:", key, caretPos);

    if (!!query) {
      if (["ArrowUp", "ArrowDown", "Enter", "Tab"].includes(key)) {
        // kepresses to be handled by Autocomplete
        this.autocompleteRef?.handleKeyPress(event);
        return;
      }
    }

    if (key == "Tab") {
      // if (caretPos == startingIndex) {
      event.preventDefault();
      if (event.shiftKey) {
        this.props.onUnindent && this.props.onUnindent();
        // this.handleUnindentItem(item)
      } else {
        this.props.onIndent && this.props.onIndent();
        // this.handleIndentItem(item)
      }
      // }
    } else if (key == "Enter") {
      console.log("enter");
      event.preventDefault();
      if (event.metaKey) {
        if (this.props.onMetaEnter) {
          event.preventDefault();
          this.props.onMetaEnter();
        }
      } else if (event.shiftKey) {
        if (this.props.onShiftEnter) {
          event.preventDefault();
          this.props.onShiftEnter();
        }
      } else if (event.altKey) {
        if (this.props.onAltEnter) {
          event.preventDefault();
          this.props.onAltEnter();
        }
      } else {
        if (this.props.handleEnter) {
          event.preventDefault();
          this.props.handleEnter();
        }
        let lineObj = richTextHelpers.getLineObject(text);
        if (!!lineObj.bullet && !lineObj.body.length) {
          if (!!lineObj.indentation) {
            this.props.onUnindent();
          } else {
            // remove bullet
            this.props.onChangeText(text.slice(startingIndex));
          }
          event.preventDefault();
        } else if (!!text?.match(/^\t* *\d+[.)] ?$/)) {
          // empty numbered item — end the list instead of continuing it
          if (!!lineObj.indentation) {
            this.props.onUnindent();
          } else {
            this.props.onChangeText("");
          }
          event.preventDefault();
        } else if (this.props.onEnter) {
          event.preventDefault();
          this.props.onEnter(
            caretPos,
            richTextHelpers.getIndentation(text),
            !!text?.match(richTextHelpers.bulletRegex),
          );
        }
      }
    } else if (key == "Backspace") {
      console.log("backspace");
      if (event.metaKey && !!this.props.onDelete) {
        event.preventDefault();
        this.props.onDelete({ shiftKey: !!event.shiftKey });
      } else if (!text?.length && !!this.props.onDeleteLine) {
        event.preventDefault();
        this.props.onDeleteLine();
      } else if (!selection || !selection[1]) {
        if (caretPos === 0 && !!this.props.mergeLineUp) {
          event.preventDefault();
          this.props.mergeLineUp();
        } else if (caretPos == startingIndex) {
          if (!!indentation && this.props.onUnindent) {
            this.props.onUnindent();
            event.preventDefault();
          } else if (!!text?.match(richTextHelpers.bulletRegex)) {
            // remove bullet
            this.props.onChangeText(text.slice(startingIndex));
            event.preventDefault();
            this.focus();
          }
        }
      }

      // if(item.text == ''){
      // this.handleDeleteItem(item)
      // }
    } else if (key == "Delete") {
      console.log("delete");
      if (caretPos == 0) {
        if (!text?.length && this.props.onDeleteLine) {
          event.preventDefault();
          this.props.onDeleteLine(true);
        }
      } else if (caretPos == text.length && !!this.props.mergeNextLineUp) {
        event.preventDefault();
        this.props.mergeNextLineUp();
      }
    } else if (key == "Escape") {
      console.log("escape");
      if (!!query.length) {
        this.setState({ query: "" });
        event.preventDefault();
        return;
      }
      if (this.state.isMomentBullet && this.state.plainText) {
        await this.setState({ plainText: false, editing: true });
        this.focus();
        return;
      }
      this.props.onEscape && this.props.onEscape();
      this.props.onCancel && this.props.onCancel();
      this.stopEditing();
      // this.setState({ query: "" });
    } else if (key == "ArrowUp") {
      // event.preventDefault();
      console.log("arrowup", caretLine, bottomLine);
      if (event.metaKey && event.ctrlKey) {
        if (this.props.metaCtrlUp) {
          event.preventDefault();
          this.props.metaCtrlUp();
        } else if (this.props.swapLineUp) {
          event.preventDefault();
          this.props.swapLineUp();
        }
      } else if (event.ctrlKey && event.altKey)
        this.props.ctrlAltUp && this.props.ctrlAltUp();
      else if (event.metaKey) !!this.props.onMetaUp && this.props.onMetaUp();
      else if (event.altKey && !!this.props.onAltUp) this.props.onAltUp();
      else if (event.altKey)
        this.props.focusPreviousJump && this.props.focusPreviousJump();
      else if (event.shiftKey && !!this.props.selectUp) {
        event.preventDefault();
        this.stopEditing();
        this.props.selectUp();
      } else if (bottomLine == null || caretLine == 1) {
        if (this.props.onNatUp) {
          event.preventDefault();
          this.props.onNatUp();
        } else if (this.props.focusPrevious) {
          this.props.focusPrevious(caretPos - startingIndex);
          // this.props.focusPrevious();
          event.preventDefault();
        }
      }
    } else if (key == "ArrowDown") {
      // event.preventDefault();
      caretLine += 1;
      console.log("arrowdown", caretLine, bottomLine);
      if (event.metaKey && event.ctrlKey) {
        if (this.props.metaCtrlDown) {
          event.preventDefault();
          this.props.metaCtrlDown();
        } else if (this.props.swapLineDown) {
          event.preventDefault();
          this.props.swapLineDown();
        }
      } else if (event.metaKey)
        !!this.props.onMetaDown && this.props.onMetaDown();
      else if (event.altKey && !!this.props.onAltDown) this.props.onAltDown();
      else if (event.altKey)
        this.props.focusNextJump && this.props.focusNextJump();
      else if (event.shiftKey && !!this.props.selectDown) {
        event.preventDefault();
        this.stopEditing();
        this.props.selectDown();
      } else if (bottomLine == null || caretLine > bottomLine) {
        if (this.props.onNatDown) {
          this.props.onNatDown();
          event.preventDefault();
        } else if (this.props.focusNext) {
          this.props.focusNext(caretPos - startingIndex);
          // this.props.focusNext();
          event.preventDefault();
        }
      }
    } else if (key == "ArrowLeft") {
      if (event.altKey && !!this.props.onAltLeft) {
        event.preventDefault();
        this.props.onAltLeft && this.props.onAltLeft();
      } else if (caretPos == 0 && !!this.props.focusPrevious) {
        event.preventDefault();
        this.props.focusPrevious(999);
      }
    } else if (key == "ArrowRight") {
      if (
        event.metaKey &&
        event.ctrlKey &&
        event.shiftKey &&
        !!this.props.onMetaCtrlShiftRight
      ) {
        this.props.onMetaCtrlShiftRight();
        event.preventDefault();
        return;
      } else if (
        event.metaKey &&
        event.ctrlKey &&
        !!this.props.onMetaCtrlRight
      ) {
        this.props.onMetaCtrlRight();
        event.preventDefault();
        return;
      } else if (event.altKey && !!this.props.onAltRight) {
        event.preventDefault();
        this.props.onAltRight && this.props.onAltRight();
      } else if (
        caretPos == this.props.children?.length &&
        !!this.props.focusNext
      ) {
        event.preventDefault();
        this.props.focusNext();
      }
    } else if (key == "t" && event.metaKey && event.shiftKey) {
      this.props.onChangeText(text + textHelpers.formatTime());
      event.preventDefault();
    }
    console.log(text, caretPos)


    this.setCaret();
    setTimeout(() => { // run again to capture pasted text
      this.setCaret();
    }, 100)
  };

  stopEditing = async (updateText = true) => {
    // if (!!this.state.query?.length) return;
    await new Promise((r) => setTimeout(r, 100));
    this.setState({ editing: false, hideCaret: true, plainText: false });
    this.props.onStopEditing(updateText);
  };

  formatRichText = (text, textProps = {}) => {
    // return <Text>{text}</Text>;
    let { color, numberOfLines } = this.props;
    let textStyle = {
      color: color,
      ...this.styles().text,
      ...(textProps.style || {}),
    };

    let res = [];
    // return text;

    let inCodeBlock = false;
    let codeBlockLines = [];
    let codeBlockStartKey = 0;

    const flushCodeBlock = (key) => {
      res.push(
        <View
          key={`codeblock-${key}`}
          style={{
            backgroundColor: colorHelpers.hexToRgbaString(
              this.context.colors.foreground,
              0.1,
            ),
            borderRadius: 4,
            padding: 8,
            marginVertical: 4,
          }}
        >
          <Text
            {...textProps}
            style={{
              fontFamily: "Courier New",
              fontSize: 14,
              lineHeight: 21,
              color: this.context.colors.foreground,
            }}
          >
            {codeBlockLines.join("\n")}
          </Text>
        </View>,
      );
      codeBlockLines = [];
    };

    const renderLine = (txt, i) => {
      if (txt.startsWith("### ")) {
        return this.applyTags(txt.replace(/#{3} /, ""), textProps, [
          textStyle,
          this.styles(textStyle).header1,
        ]);
      } else if (txt.startsWith("## ")) {
        return this.applyTags(txt.replace(/#{2} /, ""), textProps, [
          textStyle,
          this.styles(textStyle).header2,
        ]);
      } else if (txt.startsWith("# ")) {
        return this.applyTags(txt.replace(/# /, ""), textProps, [
          textStyle,
          this.styles(textStyle).header3,
        ]);
      } else if (txt.startsWith("- ")) {
        return (
          <Text key={i} {...textProps} style={[textStyle]}>
            <Text {...textProps} style={[textStyle, this.styles().bullet]}>
              •
            </Text>
            {this.applyTags(txt.replace(/- /, ""), textProps, [textStyle])}
          </Text>
        );
      } else if (/^\t- /.test(txt) || txt.startsWith("  - ")) {
        return (
          <View key={i} style={this.styles().listItem}>
            <Text {...textProps} style={[textStyle, this.styles().bullet]}>{`\t◦`}</Text>
            {this.applyTags(txt.replace(/\t- /, "").replace("  - ", ""), textProps, [textStyle])}
          </View>
        );
      } else if (/^\t\t- /.test(txt) || txt.startsWith("    - ")) {
        return (
          <View key={i} style={this.styles().listItem}>
            <Text {...textProps} style={[textStyle, this.styles().bullet]}>{`\t\t▪︎`}</Text>
            {this.applyTags(txt.replace(/\t\t- /, "").replace("    - ", ""), textProps, [textStyle])}
          </View>
        );
      } else if (/^\t\t\t- /.test(txt) || txt.startsWith("      - ")) {
        return (
          <View key={i} style={this.styles().listItem}>
            <Text {...textProps} style={[textStyle, this.styles().bullet]}>{`\t\t\t▫︎`}</Text>
            {this.applyTags(txt.replace(/\t\t\t- /, "").replace("      - ", ""), textProps, [textStyle])}
          </View>
        );
      } else {
        return this.applyTags(txt, textProps, [textStyle]);
      }
    };

    const lines = text.split(/[\r\n]/);
    let i = 0;
    while (i < lines.length) {
      let txt = lines[i];

      if (txt.trim() === "```") {
        if (!inCodeBlock) {
          inCodeBlock = true;
          codeBlockStartKey = i;
        } else {
          inCodeBlock = false;
          flushCodeBlock(codeBlockStartKey);
        }
        i++;
        continue;
      }

      if (inCodeBlock) {
        codeBlockLines.push(txt);
        i++;
        continue;
      }

      if (txt.startsWith("> ")) {
        const foldKey = i;
        const title = txt.slice(2);
        const bodyLines = [];
        let j = i + 1;
        while (j < lines.length) {
          const next = lines[j];
          if (next === "" || next.startsWith("> ") || /^#{1,3} /.test(next)) break;
          bodyLines.push(next);
          j++;
        }
        i = j;
        const isExpanded = !!this.state.foldedSections[foldKey];
        res.push(
          <View key={`fold-${foldKey}`}>
            <TouchableOpacity
              onPress={() => this.toggleFold(foldKey)}
              style={{ flexDirection: "row", alignItems: "center", gap: 4 }}
            >
              <Text style={[textStyle, { opacity: 0.4, fontSize: (textStyle.fontSize || 14) * 0.8 }]}>
                {isExpanded ? "▾" : "▸"}
              </Text>
              <Text style={[textStyle, { opacity: 0.6 }]}>
                {this.applyTags(title, textProps, [textStyle])}
              </Text>
            </TouchableOpacity>
            {isExpanded && (
              <View style={{ paddingLeft: 12, opacity: 0.85 }}>
                {bodyLines.map((line, bi) => (
                  <View key={bi}>{renderLine(line, `${foldKey}-${bi}`)}</View>
                ))}
              </View>
            )}
          </View>
        );
        continue;
      }

      res.push(renderLine(txt, i));
      i++;
    }

    if (inCodeBlock && codeBlockLines.length > 0) {
      flushCodeBlock(codeBlockStartKey);
    }

    return res;
  };

  applyTags = (string, props = {}, style = []) => {
    let rawString = string;
    let { values, momentBulletIds } = this.state;
    let content = [];

    // if (!!rawString?.length) {
    //   content.push(
    //     <Text {...props} style={style}>
    //       {`\n`}
    //     </Text>
    //   );
    // }

    let searchWords = values
      .map((v) => v.text.toLowerCase())
      .filter((x) => !!x?.length);

    searchWords = searchWords.sort((a, b) => {
      let indexA = string.indexOf(a);
      let indexB = string.indexOf(b);
      return indexA < indexB ? 1 : -1;
    });

    searchWords.forEach((word) => {
      let value = values.find((v) => v.text.toLowerCase() == word);
      let matchIndex = string?.toLowerCase().indexOf(word);
      if (matchIndex >= 0) {
        content.push(
          <Text {...props} style={style}>
            {this.applyInlineStyle(string.slice(0, matchIndex), props, style)}
          </Text>,
        );
        let matchingString = string.slice(matchIndex, matchIndex + word.length);
        if (momentBulletIds.includes(value.id)) {
          content.push(
            <MomentBullet
              moment={{ value }}
              onEscape={async () => {
                await this.setState({
                  momentBulletIds: momentBulletIds.filter(
                    (id) => id != value.id,
                  ),
                });
                this.focus();
              }}
            />,
          );
        } else {
          content.push(
            <Text
              {...props}
              style={[...style, this.styles().tagSuggestion]}
              onPressLong={(e) => {
                this.setState({
                  momentBulletIds: [...momentBulletIds, value.id],
                });
              }}
              onPress={(e) => RootNavigation.push("Value", { id: value.id }, e)}
              // onMouseDown={(e) => {
              //   e.stopPropagation();
              //   RootNavigation.push("Value", { id: value.id });
              // }}
            >
              {this.applyInlineStyle(matchingString, props, style)}
            </Text>,
          );
        }
        string = string.slice(matchIndex + word.length);
      }
    });

    if (!!string?.length) {
      content.push(
        <Text {...props} style={style}>
          {this.applyInlineStyle(string, props, style)}
        </Text>,
      );
    }

    return (
      <Text {...props} style={style}>
        {content}
      </Text>
    );
  };

  applyInlineStyle = (string, props = {}, style = []) => {
    let rawString = string;
    let content = [];

    // _italic_
    if (string.split(/_([^_]+)_/).length >= 3) {
      string.split(/_([^_]+)_/).forEach((txt, i) => {
        if (!(i % 2)) {
          if (txt.length) {
            content.push(
              <Text {...props} style={style}>
                {txt}
              </Text>,
            );
          }
        } else {
          content.push(
            <Text {...props} style={style} italic>
              {txt}
            </Text>,
          );
        }
      });
      // *bold*
    } else if (string.split(/\*([^\*]+)\*/).length >= 3) {
      string.split(/\*([^\*]+)\*/).forEach((txt, i) => {
        if (!(i % 2)) {
          if (txt.length) {
            content.push(
              <Text {...props} style={style}>
                {txt}
              </Text>,
            );
          }
        } else {
          content.push(
            <Text {...props} style={style} bold>
              {txt}
            </Text>,
          );
        }
      });
      // *hr lines*
    } else if (string == "---") {
      // /-{3}(\n)/
      content.push(
        <Text
          {...props}
          style={[...style, this.styles().hr]}
          numberOfLines={1}
          ellipsizeMode={"clip"}
        >
          {new Array(999).fill(" ").join(" ")}
        </Text>,
      );
      content.push(
        <Text {...props} style={style}>
          {` \n `}
        </Text>,
      );
      // *references*
    } else if (string.split(/{([^}]+)}/).length >= 3) {
      string.split(/{([^}]+)}/).forEach((txt, i) => {
        if (!(i % 2)) {
          if (txt.length) {
            content.push(
              <Text {...props} style={style}>
                {txt}
              </Text>,
            );
          }
        } else {
          let id = parseInt(txt.split(/[|-]/)[0]);
          let value = null;
          if (this.props.references) {
            value = this.props.references.find((v) => v.id == id);
          }
          if (!value) {
            // references may be stale or partial (moment-text refs are only
            // folded in lazily server-side) — always fall back to the store
            value = store.getState().values.find((v) => v.id == id);
          }

          let color = null;
          if (!!value) {
            txt = txt.split(/[|-]/)[1] || value.title || value.text;
            color =
              valueHelpers.getColor(value, this.context.colorScheme) ||
              this.context.colors.trim;
            color = colorHelpers.hexToRgbaString(color, 0.3);
          } else txt = "–";
          content.push(
            <Text
              {...props}
              style={[
                style,
                this.styles().tagSuggestion,
                { backgroundColor: color },
              ]}
              // onMouseDown={(e) => {
              //   e.stopPropagation();
              //   !!value && RootNavigation.push("Value", { id: value.id });
              // }}
              onPress={(e) => {
                !!value && RootNavigation.push("Value", { id: value.id }, e);
              }}
            >
              {txt}
            </Text>,
          );
        }
      });
      // *tags*
    } else if (string.split(/\|([^\|]+)\|/).length >= 3) {
      string.split(/\|([^\|]+)\|/).forEach((txt, i) => {
        if (!(i % 2)) {
          if (txt.length) {
            content.push(
              <Text {...props} style={style}>
                {txt}
              </Text>,
            );
          }
        } else {
          content.push(
            <Text {...props} style={[style, this.styles().tagSuggestion]}>
              {txt}
            </Text>,
          );
        }
      });
    } else {
      content.push(
        <Text {...props} style={style}>
          {string}
        </Text>,
      );
    }

    return (
      <Text {...props} style={style}>
        {content}
      </Text>
    );
  };

  inputMarkDownStyling = (text) => {
    let styles = [];
    // if (this.props.bold) styles.push({ fontWeight: "bold" });
    if (text.startsWith("#")) {
      styles.push(this.styles().header);
    }
    if (text.startsWith("### ")) {
      styles.push(this.styles().header1);
    } else if (text.startsWith("## ")) {
      styles.push(this.styles().header2);
    } else if (text.startsWith("# ")) {
      styles.push(this.styles().header3);
    }
    return styles;
  };

  handleCreateFromQuery = async (createProject = false) => {
    let { value, chapter } = this.props;
    let { query } = this.state;
    // if(createProject){
    //   let parent = await projectActions.create({ child_ids: [value.id]})
    // } else {
    //   let note = await noteActoins.create()
    // }
    let child = await valueActions.create(
      {
        // is_note: !createProject,
        is_note: false,
        text: query.trim(),
        parent_ids: value?.id ? [value.id] : [],
      },
      chapter?.id,
    );
    if (!!child?.id) {
      this.injectReference(child);
      this.setState({ query: "", selection: null });
      this.props.deselectAll && this.props.deselectAll();
    }
  };

  injectReference = async (refVal) => {
    let { selection, query } = this.state;
    let text = this.props.children;

    console.log(refVal, text, selection);

    if (!!selection) {
      text = `${text.slice(0, selection[0])}{${refVal.id}}${text.slice(
        selection[1],
      )}`;
    } else if (!!query) {
      // text = text.replace(/#[^ \n\r#].*/, `{${refVal.id}}`);
    }
    await this.setState({ query: "", selection: null, nativeSelection: {} });
    console.log("after", text);
    this.props.onChangeText(text);
  };

  styles = (style = { fontSize: this.context.sizes.default }) => {
    let fontSize = style.fontSize;
    let lh = 1.6;
    return {
      row: {
        flexDirection: "row",
        flexWrap: "wrap",
      },
      text: {
        fontSize: style.fontSize,
        lineHeight: style.fontSize * lh,
        // wordWrap: "none",
        cursor: "text",
        overflow: "hidden",
      },
      header: {
        marginTop: style.fontSize * 0.4,
        marginBottom: style.fontSize * 0.4,
      },
      header1: {
        fontSize: style.fontSize * 1.3,
        lineHeight: style.fontSize * 1.3 * lh,
      },
      header2: {
        fontSize: style.fontSize * 1.1,
        lineHeight: style.fontSize * 1.1 * lh,
      },
      header3: {
        fontSize: style.fontSize * 1.05,
        lineHeight: style.fontSize * 1.05 * lh,
      },
      listItem: {
        flexDirection: "row",
        flexWrap: "wrap",
      },
      bullet: {
        marginRight: style.fontSize * 0.66,
        lineHeight: style.fontSize * lh,
        fontSize: style.fontSize * 1.5,
      },
      // tags
      tagSuggestion: {
        backgroundColor: this.context.colors.fill,
        borderRadius: this.context.sizes.small,
        cursor: "pointer",
        paddingHorizontal: this.context.sizes.tiny,
      },
      // hr
      hr: {
        borderBottomWidth: 1,
        borderColor: this.context.colors.foreground,
        opacity: 0.5,
      },
      autocompleteWrapper: {
        zIndex: 99,
        position: "absolute",
        top: "100%",
        left: 0,
        // right: 0,
        // flexDirection: "row",
        // justifyContent: "flex-end",
        backgroundColor: colorHelpers.hexToRgbaString(
          this.context.colors.trim,
          0.9,
        ),
      },
    };
  };
}
